import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';

import {environment} from '../../../../../environments/environment';
import {Severity, ToastService} from '../../../../shared/components/toast/toast.service';
import {Subscription} from 'rxjs';
import {SigningService} from '../signing/signing.service';

@Component({
  selector: 'app-sign-progress',
  templateUrl: './sign-progress.component.html'
})
export class SignProgressComponent implements OnInit, OnChanges, OnDestroy {

  baseWebSocketURL: string = environment.baseWebSocketURL;

  @Input() display?: number;
  @Input() onMessage: () => void = () => {
  };

  header: string = '';
  isSuccess?: string;
  listening?: boolean;

  webSocket?: WebSocket;
  pingInterval: any;
  displaySubscription?: Subscription;

  constructor(
    private toastService: ToastService,
    private certificatedService: SigningService,
  ) {

  }

  ngOnInit(): void {

    this.displaySubscription = this.certificatedService.displaySubject.subscribe(res => {
      if (res === 'signProgress') {
        this.listening = true;
        this.isSuccess = undefined;
        this.initWebSocket();
        this.toastService.setMessage({severity: Severity.INFO, detail: 'Chờ xác nhận chữ ký số...'});
      }
    });
  }

  initWebSocket(): void {
    const origin = location.origin.replace('http', 'ws').replace('https', 'wws');
    this.webSocket = new WebSocket(`${origin}/${this.baseWebSocketURL}`);
    this.webSocket.addEventListener('open', () => {
      this.webSocket?.send('subscribe:SignedResult');
    });

    this.webSocket.onclose = (e) => {
      if (e.reason !== 'unmount') {
        this.initWebSocket();
      }
    }
    this.webSocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.topic === 'SignedResult') {
        if (this.onMessage) {
          this.onMessage();
        }
        if (this.listening) {
          this.listening = false;
          this.isSuccess = data.message.isSuccess;
          if (this.isSuccess === 'Y') {
            this.toastService.setMessage({severity: Severity.SUCCESS, detail: 'Đã ký thành công!'});

          } else {
            this.toastService.setMessage({severity: Severity.ERROR, detail: 'Có lỗi xảy ra'});
          }
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy(): void {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
    }
    if (this.webSocket) {
      this.webSocket.close(3010, 'unmount');
    }
  }

}
